/* import __COLOCATED_TEMPLATE__ from './overview-report-heading.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();